const state = {
  isMusicOn: false
}

const getters = {
  generateAudioPath: () => {
    return new Audio(require(`@/assets/audio/bg-audio.mp3`))
  },
  generateCrossAudioPath: () => {
    return new Audio(require(`@/assets/audio/sample.mp3`))
  },
  generateHoverAudioPath: () => {
    return new Audio(require(`@/assets/audio/hover.mp3`))
  },
  generateOpenAudioPath: () => {
    return new Audio(require(`@/assets/audio/open.mp3`))
  }
}

const mutations = {
  updateAudioStatus: (state, payload) => {
    state.isMusicOn = payload
  }
}

const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
